import Vue from 'vue'

/**
 * Simple event bus is just a vue instance
 *
 * todo: just provide the $emit and $on interace
 */
const EventBus = Vue

export default EventBus
